import type {TypedAggregationResource} from '@common/composables';

/**
 * FinOps / Customer Success manager buckets occasionally come back with empty value+label.
 * Those are not shown as filter options (see finOpsManagerAggregations & companySuccessManagerAggregations).
 */
export function filterDisplayableManagerBuckets<T extends string>(items: TypedAggregationResource<T>[] | undefined): TypedAggregationResource<T>[] {
    return (items ?? []).filter((item) => Boolean(item.value) && Boolean(item.label));
}
